import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import Multiselect from 'react-widgets/lib/Multiselect';

import { querySelector } from '../../../utils';

/* eslint-disable */
const propTypes = {
  equipment: PropTypes.array.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
/* eslint-enable */

export class EquipmentPicker extends Component {
  render() {
    const { equipment, value, onChange } = this.props;
    return (
      <div>
        <Multiselect
          value={value}
          onChange={onChange}
          data={equipment}
          textField={(item) => { return `${item.equipment_number}`; }}
        />
      </div>
    );
  }
}

const GetAllEquipmentQuery = gql`
  query GetAllEquipment {
    all_equipment {
      edges {
        node {
         id
         equipment_number
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const equipment = querySelector(data, '$.all_equipment.edges[*].node', []);
  return {
    ...ownProps,
    data,
    equipment,
  };
};

const withData = graphql(GetAllEquipmentQuery, { props: marshallData });

EquipmentPicker.propTypes = propTypes;

export default withData(EquipmentPicker);
